import { FC } from 'react';
import { Button, Image, Space, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { DATE_FORMAT, TIME_FORMAT } from 'constants/dates';
import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { useUIDispatchContext } from 'providers/UI';

import { getNoteText } from 'utils/getNoteText';
import { getFileUrl } from 'utils/file';
import { UploadPreview } from './components';
import {
  StyledReportCard,
  StyledReportCardContent,
  StyledTitle
} from './styled';

const { Text } = Typography;

interface IProps {
  id: string;
  date?: string | null;
  file?: string | null;
  note?: string | null;
}

const ReportFileCard: FC<IProps> = ({ id, date, file, note }) => {
  const { t } = useTranslation();

  const { toggleModal } = useUIDispatchContext();

  return (
    <>
      <StyledReportCard>
        <StyledTitle>
          <Space>
            <Text style={{ fontWeight: 'bold' }}>#{id}</Text>
            <Tag color="#48CA8C">{t('reports.report_sent')}</Tag>
          </Space>
          <Text style={{ fontWeight: 500, color: '#6B7083' }}>
            {date ? dayjs(date).format(`${DATE_FORMAT} ${TIME_FORMAT}`) : '-'}
          </Text>
        </StyledTitle>
        <StyledReportCardContent direction="vertical" size={12}>
          <Text style={{ fontWeight: 'bold' }}>{t('reports.report')}</Text>
          {!!file && (
            <div>
              <Image src="/images/format-pdf.svg" preview={false} width={24} />
              <span style={{ marginLeft: 4 }}>{file}</span>
            </div>
          )}
          {!!note && (
            <div
              className="report-text"
              dangerouslySetInnerHTML={{
                __html: getNoteText(note)
              }}
            />
          )}
          <Space size={16}>
            {!!file && (
              <a
                href={getFileUrl(file)}
                target="_blank"
                download={file}
                rel="noreferrer"
              >
                <Button icon={<DownloadOutlined />} type="primary" ghost>
                  {t('reports.download')}
                </Button>
              </a>
            )}
            {!!file && (
              <Button
                icon={<EyeOutlined />}
                onClick={() => {
                  toggleModal('uploadPreview', true, {
                    id,
                    file,
                    note: note || ''
                  });
                }}
              >
                {t('reports.view_report')}
              </Button>
            )}
          </Space>
        </StyledReportCardContent>
      </StyledReportCard>
      <UploadPreview />
    </>
  );
};

export default ReportFileCard;
